import React from "react";
import { useLocation } from "react-router-dom";

const Thankyou = () => {
  const { state } = useLocation();

  return (
    <>
      <section id="thankyou" className="thankyou" style={{ padding: "100px 0", minHeight: "60vh" }}>
        <div className="container">
          <div className="row justify-content-center">
            <div className="col-lg-8 text-center" data-aos="fade-up">
              <div 
                style={{
                  width: "100px",
                  height: "100px",
                  borderRadius: "50%",
                  background: "#10b981",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  margin: "0 auto 30px",
                  boxShadow: "0 4px 20px rgba(16, 185, 129, 0.3)"
                }}
              >
                <i 
                  className="bi bi-check-lg" 
                  style={{
                    fontSize: "50px",
                    color: "#fff",
                    fontWeight: "bold"
                  }}
                ></i>
              </div>
              <h1 style={{ 
                fontFamily: "'Poppins', sans-serif",
                fontSize: "2.5rem",
                color: "#0f172a",
                marginBottom: "20px"
              }}>
                Thank You!
              </h1>
              <p style={{
                fontFamily: "'Inter', sans-serif",
                fontSize: "1.2rem",
                color: "#64748b",
                lineHeight: "1.8",
                maxWidth: "600px",
                margin: "0 auto"
              }}>
                Thank you for contacting us. We have received your message and will
                get back to you shortly.
              </p>
              {state?.delivery === "google-sheets" && (
                <p className="text-success mt-3">
                  Your request was sent to our support sheet.
                </p>
              )}
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default Thankyou;
